module.exports = __webpack_public_path__ + "static/media/eatingformulation.bb559fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Library Formulations/eatingformulation.png
// module id = 1246
// module chunks = 2